import { FC, PropsWithChildren } from 'react';
import { StarIcon } from '@heroicons/react/24/solid';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import IconListElement from '@/components/ui/IconListElement/IconListElement.tsx';

const StarListElement: FC<PropsWithClassName<PropsWithChildren>> = ({ children, className }) => (
  <IconListElement className={className} icon={StarIcon}>
    {children}
  </IconListElement>
);

export default StarListElement;
